export default __webpack_public_path__ + "static/media/attempt2.c87a01ca.png";